import dealershipSlice from './slice'

const { setPage } = dealershipSlice.actions

export { setPage }

export default dealershipSlice.reducer
